export class ProductLampshades extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-default-selection-id', 'data-variant-id']
  }

  /**
   * @type {Array<ProductLampshadesOption>}
   */
  options = []

  /**
   * @type {Array<{ option: ProductLampshadesOption, quantity: number }>}
   */
  selections = []

  connectedCallback () {
    super.connectedCallback()

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        this.setFormState(this.selections.length === 0)
        this.#updateProductForms()
      },
      {
        once: true,
      },
    )

    for (const productForm of this.productForms) {
      const productFormEl = productForm.closest('product-form')
      if (!productFormEl) continue

      productFormEl.addBeforeSubmitHandler(async (e) => {
        const lampshadesKey = window.crypto.randomUUID()
        const lampshadeKeyInputs = productFormEl.querySelectorAll(
          `[name*="_lampshade_key"]`,
        )

        for (const lampshadeKeyInput of lampshadeKeyInputs) {
          lampshadeKeyInput.value = lampshadesKey
        }

        const mainQuantity = productFormEl.querySelector(
          `input[name="quantity"]`,
        )
        const itemQuantityInputs = productFormEl.querySelectorAll(
          `input[name="items[0][quantity]"], input[name="items[1][quantity]"]`,
        )

        for (const itemQuantityInput of itemQuantityInputs) {
          itemQuantityInput.value = mainQuantity.value
        }
      })
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this,
      'OptionSelected',
      this.#onOptionSelection.bind(this),
    )
  }

  /**
   * Handles when an option is selected in a product group
   * @listens CustomEvent#OptionSelected
   * @param {CustomEvent} event - The option selected event
   * @param {Object} event.detail - The event details
   * @param {ProductLampshadesOption} event.detail.selectedOption - The option element where the selection was made
   */
  #onOptionSelection (event) {
    this.#updateProductForms()

    window.setTimeout(() => {
      event.detail.selectedOption.trigger.updateSelectedDisplay(
        event.detail.selectedOption,
      )
    }, 10)
  }

  #updateProductForms () {
    /**
     * Creates a hidden input element
     * @param {string} name
     * @param {string} value
     */
    const createHiddenInput = (name, value) => {
      for (const productForm of this.productForms) {
        let inputElement = window.BAO.Utils.getElement(`[name="${name}"]`, {
          context: productForm,
        })

        if (!inputElement) {
          inputElement = window.BAO.Utils.createElement('input', {
            type: 'hidden',
            name,
          })

          productForm.appendChild(inputElement)
        }

        inputElement.value = value
      }
    }

    const lampshadesKey = window.crypto.randomUUID()

    createHiddenInput(`items[0][id]`, this.dataset.variantId)
    createHiddenInput(`items[0][quantity]`, '1')
    createHiddenInput(`items[0][properties][_lampshade_key]`, lampshadesKey)

    if (this.selections.length > 0) {
      createHiddenInput(
        `items[1][id]`,
        this.selections[0].option.dataset.variantId,
      )
      createHiddenInput(`items[1][quantity]`, '1')
      createHiddenInput(`items[1][properties][_lampshade_key]`, lampshadesKey)
    }

    this.setFormState(this.selections.length === 0)

    for (const productForm of this.productForms) {
      const idInput = productForm.querySelector(`[name="id"]`)
      if (idInput) idInput.remove()
    }
  }

  /**
   * @param {boolean} shouldBeDisabled
   */
  setFormState (shouldBeDisabled) {
    for (const productForm of this.productForms) {
      const submitElement = Array.from(productForm.elements).find(
        (element) => element.type === 'submit',
      )

      if (shouldBeDisabled) {
        submitElement?.setAttribute('disabled', shouldBeDisabled.toString())
      } else {
        submitElement?.removeAttribute('disabled')
      }
    }
  }

  /**
   * @returns {HTMLFormElement[]}
   */
  get productForms () {
    const idInputs = window.BAO.Utils.getElements(
      `[name="id"][value="${this.dataset.variantId}"], [name="items[0][id]"][value="${this.dataset.variantId}"]`,
    )

    return idInputs.map((input) => input.closest('form'))
  }
}

if (!customElements.get('product-lampshades')) {
  customElements.define('product-lampshades', ProductLampshades)
}
